export const translations = {
  tr: {
    nav: {
      all: "Tümü",
      providers: "Sağlayıcılar",
      contact: "İletişim",
      slots: "Slotlar",
      casino: "Live Casino",
      original: "Marsilya",
    },
    header: {
      search: "Oyun veya sağlayıcı ara",
      home: "Ana sayfa",
      login: "Giriş Yap",
      register: "Kayıt Ol",
      logout: "Çıkış yap",
      logoutShort: "Çıkış",
      balance: "Bakiye",
      wallet: "Cüzdan",
      bonusShort: "Bonus {{amount}}",
      depositShort: "Yatır",
      account: "Hesabım",
      inbox: "Gelen kutusu",
      payments: "Yatırım / Çekim",
      admin: "Admin paneli",
      supportDesk: "Destek masası",
      cashier: "Sahacı paneli",
      accountMenu: "Hesap menüsü",
      menu: "Menü",
      searchFx: "Para birimi ara",
      walletSettings: "Cüzdan ayarları",
    },
    sidebar: {
      menu: "MENÜ",
      originals: "MARSILYA OYUNLARI",
      games: "OYUNLAR",
      betting: "BAHİS",
      account: "HESAP",
      playNowDesc: "Öne çıkan oyunlar tek ekranda",
      sport: "Spor & İddaa",
      esport: "Espor",
      crypto: "Kripto Tahmin",
      telegram: "Telegram kanalı",
      language: "Dil",
      support: "Canlı destek",
      chat: "Sohbet",
      allGames: "Tümü",
      slots: "Slotlar",
      liveCasino: "Live Casino",
      marsilya: "Marsilya",
      playNow: "Hemen oyna",
      wallet: "Cüzdanım",
      providers: "Sağlayıcılar",
      contact: "İletişim",
      mines: "Mayın",
      wheel: "Çark",
      dice: "Zar",
      vip: "VIP / Rank",
    },
    vip: {
      heroTitle: "Oynadıkça yüksel, yükseldikçe kazan",
      heroLead: "Initié ile başla; onaylı yatırımların arttıkça Élite, Prestige ve üzeri ranklara çık. Her kademede bonus ve ayrıcalıklar genişler.",
      heroVolume: "Rank hacmi = onaylanmış gerçek yatırımların toplamı (IBAN / kripto). Oyun çevrimi rank sayacına eklenmez.",
      register: "Kayıt ol",
      seeLevels: "Seviyeleri gör",
      myRank: "Rankim",
      current: "Şu anki rank",
      toNext: "sonraki eşiğe",
      approvedDeposits: "onaylı yatırım",
      startInitie: "İlk rank Initié — en az 500 ₺ onaylı yatırımla açılır.",
      requiredVolume: "Gerekli hacim",
      volumeHint: "Onaylı yatırım toplamı",
      levelBonus: "Seviye atlama bonusu",
      levelBonusHint: "Rank atlandığında tanımlanan ödül",
      lossBonus: "Kayıp bonusu",
      lossGame: "oyun bahisleri",
      lossSport: "spor & espor",
      perks: "Ayrıcalıklar",
      nextTier: "Sonraki rankte",
      rankThreshold: "Bu rank için minimum onaylı yatırım: {{amount}}",
      wagerTitle: "Yatırım, bonus ve çevrim",
      wager1: "Rank yalnızca onaylanmış yatırımlardan sayılır; demo bakiye ve iptal edilen talepler dahil değildir.",
      wager2: "Hoş geldin, haftalık ve doğum günü bonusları bonus bakiyesine gider; çekim için bonus çevrimi (ör. 10x) tamamlanmalıdır.",
      wager3: "Kayıp bonusları oyun/spor hacminden birikir; çevrim şartı olmadan ana bakiyeye aktarılabilir (Hesabım → Bonus).",
      howTitle: "Nasıl yükselirsin?",
      step1Label: "ADIM I",
      step1Title: "Onaylı yatırım yap",
      step1Text: "IBAN veya kripto ile yatırımını tamamla. Yönetim onayından sonra tutar rank hacmine eklenir; oyun çevrimi sayılmaz.",
      step2Label: "ADIM II",
      step2Title: "Hacim arttıkça rank yüksel",
      step2Text: "Toplam onaylı yatırımın Initié (500 ₺), Élite (2.000 ₺), Prestige (5.000 ₺) ve üzeri eşikleri geçtikçe rank otomatik güncellenir.",
      step3Label: "ADIM III",
      step3Title: "Rank ayrıcalıklarını kullan",
      step3Text: "Kayıp bonusu, haftalık yatırım bonusu, rakeback ve VIP destek gibi ödüller rankına göre açılır.",
      faqTitle: "Sıkça sorulan sorular",
      faq1q: "VIP / rank programı nedir?",
      faq1a: "Marsilya’da Initié’den Suprême’ye altı rank vardır. Sadakat hacmi yalnızca onaylanmış gerçek yatırımlardan oluşur; her kademede bonus ve ayrıcalıklar genişler.",
      faq2q: "Rankımı nasıl yükseltirim?",
      faq2a: "Onaylı IBAN veya kripto yatırımların toplanır. Eşiği geçtiğinde rankın otomatik yükselir. İlerlemeni Hesabım ve bu sayfadaki slider’dan takip edebilirsin.",
      faq3q: "Bonus çevrimi ranka sayılır mı?",
      faq3a: "Hayır. Rank hacmi sadece onaylı yatırımdır. Bonus bakiyesi ve oyun çevrimi rank sayacına eklenmez; bonusların kendi çevrim kuralları ayrıdır.",
      faq4q: "Seviye atlama bonusu ne zaman gelir?",
      faq4a: "Rank eşiğine ulaştığında tanımlanan ödüller ve açılan ayrıcalıklar hesabında görünür. Kayıp bonusları oynadıkça birikir, Hesabım’dan talep edilir.",
    },
    lobby: {
      playNow: "Hemen oyna",
      heroTitlePrefix: "Marsilya'da",
      heroTitleHighlight: "%100",
      heroTitleInline: "",
      heroTitleLine2: "hoşgeldin bonusu",
      heroDesc: "Slot, canlı casino ve Marsilya orijinal masaları. Hemen oyna, anında çek.",
      heroClaim: "Bonusu al",
      bonusKicker: "Aktif kampanyalar",
      bonusTitle: "Bonuslar burada — kaçırma",
      bonusLead: "Hoşgeldin, haftalık yatırım ve kayıp iadesi tek yerde. Talep et, hemen oyna.",
      bonusWelcomeTag: "Yeni üye",
      bonusWelcomeTitle: "%100 hoşgeldin",
      bonusWelcomeDesc: "İlk yatırım kaybından sonra eşleşen bonus · 10x çevirim",
      bonusWeekTag: "Her hafta",
      bonusWeekTitle: "Haftalık yatırım",
      bonusWeekDesc: "Haftalık yatırımlarına ekstra bonus",
      bonusRakeTag: "Slot & orijinal",
      bonusRakeTitle: "Kayıp iadesi",
      bonusRakeDesc: "Seçili oyunlarda kayıp bonusu",
      bonusAll: "Tüm bonusları gör",
      egtBannerTitle: "EGT Digital slotları",
      egtBannerDesc: "250+ oyun · Burning Hot, Rise of Ra ve daha fazlası",
      egtBannerCta: "EGT slotlarını aç",
      popular: "Popüler oyunlar",
      popularDesc: "En çok açılan Pragmatic masaları",
      popularLoading: "Popüler oyunlar güncelleniyor…",
      featured: "Öne çıkan oyunlar",
      originals: "Marsilya Oyunları",
      originalsDesc: "Zar, Aviator, Mayın ve diğer orijinaller",
      marsilyaGames: "Marsilya Oyunları",
      marsilyaGamesDesc: "Zar, Aviator, Mayın, Plinko, Limbo ve Çark",
      allGames: "Tüm oyunlar",
      slots: "Slotlar",
      slotsDesc: "Pragmatic ve diğer popüler slotlar",
      casino: "Casino",
      liveCasino: "Live Casino",
      liveCasinoDesc: "Rulet, blackjack ve canlı masalar",
      seeAll: "Tümünü gör",
      seeMore: "Daha fazlası",
      popularSlots: "Popüler slot oyunları",
      providers: "Sağlayıcılar",
      providersDesc: "Stüdyoları ayrı gez, istediğini aç",
      recent: "Son oynananlar",
      recentDesc: "Az önce açtığın masalar",
      removeRecent: "Listeden kaldır",
      originalGames: "Marsilya Oyunları",
      filterAll: "Tümü",
      gamesLoading: "Oyunlar yükleniyor…",
      showing: "{{count}} gösteriliyor",
      totalGames: "{{total}} oyun",
      loadMore: "Daha fazla oyun ({{count}} kaldı)",
      liveCasinoBets: "Casino Bahisleri",
      liveGame: "Oyun",
      liveUser: "Kullanıcı",
      liveTime: "Zaman",
      liveBet: "Bahis Tutarı",
      liveMult: "Çarpan",
      livePayout: "Ödeme",
      liveHidden: "Gizlenmiş",
    },
    badge: {
      popular: "POPÜLER",
      original: "MARSILYA",
    },
    auth: {
      login: "Giriş Yap",
      register: "Kayıt Ol",
      loginTitle: "Marsilya Bet'e Giriş Yap",
      registerTitle: "Hesap oluştur",
      loginLead: "Sınırsız kazanç için hesabına bağlan.",
      login2fa: "Google Authenticator kodunu gir.",
      registerLead: "Ad soyad, GSM ve hesap bilgilerinle hemen başla.",
      refCode: "Referans kodu",
      refCodeHint: "İsteğe bağlı. Linkle geldiysen otomatik dolar, yoksa elle yazabilirsin.",
      captcha: "Captcha doğrulamasını tamamla.",
      captchaLabel: "Güvenlik kodu",
      captchaPlaceholder: "Kodu yaz",
      captchaRefresh: "Kodu yenile",
      visualLead: "Slot, canlı casino ve Marsilya orijinal masaları. Telegram’dan duyuruları kaçırma.",
    },
    account: {
      overview: "Hesap",
      settings: "Ayarlar",
      offers: "Bonuslar",
      prefs: "Tercihler",
      password: "Şifre",
      oldPass: "Eski Şifre",
      newPass: "Yeni Şifre",
      newPass2: "Yeni Şifreyi Onayla",
      save: "Kaydet",
      twoFaTitle: "İki Faktör",
      twoFaLead: "Hesabını bağlamak için QR kodunu tarayın, ardından doğrulama uygulamanızdaki kodu girin.",
      privacy: "Gizlilik",
      privacyLead: "Bu ayarlar, diğer oyuncuların seni nasıl gördüğünü belirler.",
      community: "Topluluk",
      prefGhost: "Hayalet Modunu Etkinleştir",
      prefGhostDesc: "Kullanıcı adın genel bahis akışında ve bahis ön izlemesinde görünmez.",
      prefWins: "Tüm istatistiklerini gizle",
      prefWinsDesc: "Kazançların, kayıpların ve toplam bahislerin diğer kullanıcılara gösterilmez.",
      prefRace: "Tüm yarış istatistiklerini gizle",
      prefRaceDesc: "Yarış istatistiklerin diğer kullanıcılara gösterilmez.",
      prefTips: "Bahşiş yazmanı almayı engelle",
      prefTipsDesc: "Sohbet odasında bahşiş yazmanı almayı engeller.",
      prefWait: "Güncellemenin etkili olması için lütfen yaklaşık 30 saniye bekleyin.",
      prefInstant: "Değişiklikler anında uygulanır ve hesabına kaydedilir.",
      experience: "Deneyim",
      experienceLead: "Yayın, ses ve bildirim tercihlerin.",
      privateProfile: "Özel profil",
      privateProfileDesc: "E-posta, GSM ve ad soyad bu sayfada maskelenir.",
      hideActivity: "İşlem tutarlarını gizle",
      hideActivityDesc: "Geçmişteki bahis ve kazanç tutarlarını •••• olarak gösterir.",
      stealthIp: "IP gizle",
      stealthIpDesc: "Oturum listesinde son IP adresin görünmez.",
      hideBonus: "Bonus bakiyeyi gizle",
      hideBonusDesc: "Üst menüdeki bonus tutarını ekran paylaşımında kapatır.",
      muteSfx: "Oyun seslerini kapat",
      muteSfxDesc: "Zar, çark ve orijinal oyun efektlerini susturur.",
      rainIgnore: "Yağmur ve chat drop'larını yoksay",
      rainIgnoreDesc: "Sohbetteki rain/drop bildirimlerini gizler.",
      streamerOn: "Yayıncı",
      ghostOn: "Hayalet",
      privateHint: "Profil bilgileri gizli",
      wagered: "Bahis hacmi",
      ipHidden: "IP gizli",
      prefSaved: "Tercihler kaydedildi",
      verified: "Doğrulandı",
      copy: "Kopyala",
      emailLead: "E-posta adresin resmi iletişim ve hesap güvenliği için kullanılır.",
      phoneTitle: "Telefon Numarası",
      phoneLead: "Kayıtlı telefon numaran.",
      deposit: "Yatırım",
      withdraw: "Çekim",
      paylog: "Yatırım & çekim",
      history: "İşlemler",
      security: "Güvenlik",
      inbox: "Mesajlar",
      profile: "Profilim",
      profileLead: "Hesap bilgilerin, güvenlik durumun ve hızlı işlemler.",
      balance: "Kullanılabilir bakiye",
      bonusLocked: "çekilemez",
      session: "Oturum",
      loginRequired: "Hesabına erişmek için giriş yap.",
      noPhone: "GSM kayıtlı değil",
      username: "Kullanıcı adı",
      email: "E-posta",
      fullName: "Ad soyad",
      phone: "GSM",
      totalDeposit: "Toplam yatırım",
      rankNow: "Şu anki rankınız",
      rankNext: "Bir sonraki rank ({{name}}) için {{amount}} daha yatırım yapmanız gerekmekte.",
      rankMax: "En üst ranktasınız. Suprême seviyesindesiniz.",
      rankDeposited: "Toplam yatırım {{amount}}",
      rankNeed: "sonraki eşik {{amount}}",
      rankTitle: "Rank-up ve liderlik",
      rankLead: "Yatırımın rankını belirler. En yüksek rankdaki oyuncu liderlikte birinci olur.",
      rankBoard: "Liderlik tablosu",
      rankLeader: "En yüksek rank",
      rankEmpty: "Henüz sıralama yok",
      rankAllLevels: "Tüm seviyeler ve ayrıcalıklar",
      photoType: "Sadece JPG veya PNG yükle",
      photoMax: "Fotoğraf en fazla 2 MB olabilir",
      photoOk: "Profil fotoğrafı güncellendi",
      photoHint: "JPG/PNG · max 2 MB",
      weeklyTitle: "Haftalık yatırım bonusu",
      weeklyDesc: "Kayıttan 7 gün sonra her hafta o hafta yatırdığının %5’i hesabına eklenir.",
      weeklyWeek: "Bu hafta yatırım",
      weeklyBonus: "Alınacak bonus",
      weeklyClaim: "{{amount}} al",
      weeklyBusy: "Ekleniyor…",
      weeklyClaimed: "Haftalık bonus eklendi",
      weeklyDone: "Bu haftanın bonusunu aldın. Pazartesi yeniden açılır.",
      weeklyLocked: "Kayıttan 7 gün sonra açılır. Kalan: {{time}}",
      weeklyNeed: "Bonus için bu hafta yatırım yap",
      rakeTitle: "Oyun kayıp bonusu",
      rakeDesc: "Gerçek bakiyeyle kaybettiğin bahsin %1’i burada birikir. Hesaba kendiliğinden geçmez, sen alırsın.",
      affiliate: "Affiliate",
      affiliateCode: "Affiliate kodu",
      affiliateRate: "Oran",
      affiliateEarned: "Kazancın",
      affiliateHouse: "Referans kasa",
      affiliateReferrals: "Kayıt",
      affiliateLead: "Senin linkinle kayıt olanların kaybettiği kasadan payın yatar.",
      twoFa: "2FA güvenlik",
      twoFaOn: "Açık",
      twoFaOff: "Kapalı",
      depositBtn: "Yatırım yap",
      withdrawBtn: "Çekim talep et",
      historyBtn: "İşlem geçmişi",
      supportChat: "Canlı desteğe git",
      supportNew: "Admin ile mesajlaş",
      welcomeBonus: "%100 Hoşgeldin bonusu",
      welcomeBonusDesc: "İlk yatırımını kaybettikten sonra %100 bonus al. 10x çevirim şartı var: 1.000 ₺ bonus için 10.000 ₺ bahis. Çevirim bitince çekim açılır.",
      bonusWagerTitle: "Çevirim şartı",
      bonusWagerProgress: "{{wagered}} / {{required}} çevrildi",
      bonusWagerLeft: "Çekim için kalan çevirim: {{left}}",
      bonusWagerDone: "Çevirim tamam. Bonus bakiyen nakde döndü.",
      bonusWagerLocked: "Bonus 10x çevirimi bitmeden çekim talebi açılamaz.",
      bonusClaimedNote: "Bonus hesabında. Orijinal oyunlarda 10x çevir, 2/10 oranında ödeme alırsın.",
      copyInvite: "Davet linkini kopyala",
      bankTransfer: "Havale / EFT",
      bankTransferSub: "TL yatırım",
      crypto: "Kripto",
      cryptoSub: "USDT, TRX, LTC, XMR…",
      hideName: "Kullanıcı adını gizle",
      hideNameDesc: "Canlı bahislerde ve kazanç akışında adın Hidden görünür.",
      hideBalance: "Bakiyeyi gizle",
      hideBalanceDesc: "Profil önizlemesinde bakiyen diğer oyunculara gösterilmez.",
      streamer: "Yayıncı modu",
      streamerDesc: "Ekran paylaşımlarında yüksek kazançları ve bakiyeyi soluklaştırır.",
      loginAlerts: "Giriş bildirimleri",
      loginAlertsDesc: "Yeni bir cihazdan giriş olursa e-posta gönder.",
      sessions: "Oturumlar",
      sessionsLead: "Hesabına bağlı cihazlar. Şüpheli bir oturumu kapat.",
      thisDevice: "Bu cihaz",
      currentSession: "Aktif oturum",
      verify: "Kimlik onayı",
      verifyTitle: "Kimlik onayı",
      verifyLead: "IBAN çekimi için T.C. kimlik numaranı doğrula. Gelen ad soyad hesaba yazılır.",
      verifyPending: "Doğrulanmadı",
      verifyOk: "Onaylı",
      verifyNeed: "TCKN, nüfus kaydındaki ad ve soyadını hesaba işler. Çekim IBAN sahibi bu isimle aynı olmalı.",
      verifyIbanMatch: "IBAN hesap adı ile kimlikteki ad soyad aynı olmalıdır. Farklıysa çekim onaylanmaz.",
      kycTckn: "T.C. kimlik no",
      kycSubmit: "Kimlik onayla",
      kycIbanNeed: "IBAN çekimi için önce kimlik onayını tamamla.",
      marketing: "Kampanya e-postaları",
      marketingDesc: "Bonus, turnuva ve reload duyuruları.",
      notifySite: "Site içi bildirimler",
      notifySiteDesc: "Yatırım onayı, çekim ve destek mesajları.",
      joined: "Kayıt",
      kyc: "Kimlik onayı",
      recover: "Kurtarma e-postası",
      recoverDesc: "2FA kaybedersen hesabı bu adresle açarsın.",
    },
    games: {
      kicker: "MARSILYA ORİJİNAL",
      betLabel: "Bahis ({{symbol}})",
      manual: "Manuel",
      auto: "Otomatik",
      risk: "Risk",
      riskLow: "Düşük",
      riskMed: "Orta",
      riskHigh: "Yüksek",
      rows: "Satırlar",
      ballCount: "Top sayısı",
      totalBet: "Toplam bahis {{amount}}",
      bet: "Bahis",
      stop: "Durdur",
      targetMult: "Hedef çarpan",
      fly: "Uçur",
      spin: "Çarkı çevir",
      autoSpin: "Otomatik çevir",
      heads: "Yazı",
      tails: "Tura",
      start: "Başlat",
      cashout: "Çek",
      cancelRefund: "İptal · iade {{amount}}",
      nextBox: "Sonraki kutu",
      mineCount: "Mayın sayısı",
      bonusNote: "Bonus {{amount}} · çevirim {{wagered}} / {{required}} · 10x şart, çekim bitince açılır.",
      loading: "Oyun yükleniyor…",
      backHub: "Oyunlar",
      mute: "Sesi kapat",
      unmute: "Sesi aç",
      bonusChip: "Bonus {{amount}}",
      mines: {
        title: "Mayın",
        desc: "Mayın sayısını ayarla, güvenli kutuları aç, mayına basmadan çek.",
      },
      plinko: {
        title: "Plinko",
        desc: "Risk ve satır seç, topu bırak.",
      },
      limbo: {
        title: "Limbo",
        desc: "Hedef çarpanı seç. Sonuç hedefi geçerse kazanırsın.",
      },
      wheel: {
        title: "Çark",
        desc: "Çarkı çevir, dilimin çarpanını al.",
      },
      dice: {
        title: "Zar",
        desc: "1–6 arası sayı seç. Tutturursan 20x.",
      },
      defaultTitle: "Oyun",
    },
    play: {
      back: "Geri",
      mute: "Sesi kapat (M)",
      unmute: "Sesi aç (M)",
      demoMode: "Demo mod · ",
      demoAlert: "Demo moddasın — kayıt olmadan oyunu deneyebilirsin. Gerçek oynamak için",
      or: "veya",
      register: "kayıt ol",
      login: "giriş yap",
      deposit: "Yatırım",
      loading: "Oyun yükleniyor…",
      defaultTitle: "Oyun",
      fullscreen: "Tam ekran",
      exitFullscreen: "Tam ekrandan çık",
      gateBalance: "Bakiye",
      currency: "Para birimi",
      currencyTry: "Oyunlar yalnızca Türk lirası (TRY) ile açılır.",
      registerBtn: "Kayıt ol",
      loginBtn: "Giriş yap",
      demoBtn: "Demo",
      realBtn: "Gerçek bakiye",
      askMode: "Gerçek bakiye mi, demo mu?",
      moreFrom: "{{provider}} oyunları",
      viewAll: "Tümünü gör",
      providers: "Sağlayıcılar",
      theatre: "Genişlet",
      real: "Gerçek",
      fun: "Demo",
    },
    playHub: {
      title: "Hemen oyna",
      desc: "Slot, canlı casino ve Marsilya orijinalleri — tek ekrandan seç, anında başla.",
      exploreSlots: "Slotları keşfet",
      goOriginals: "Orijinallere git",
      categories: "Oyun kategorileri",
      slotsDesc: "Pragmatic ve popüler sağlayıcı slotları",
      casinoDesc: "Blackjack, rulet ve canlı casino masaları",
      gamesLabel: "oyun",
      liveLabel: "canlı masa",
      statOriginals: "6 orijinal oyun",
      statInstant: "Anında başlat",
      statFair: "Provably fair",
      popularTitle: "Popüler masalar",
      popularDesc: "En çok tercih edilen oyunlar",
      pickBlackjack: "Canlı & RNG blackjack",
      pickRoulette: "Avrupa rulet masaları",
      pickAviator: "Crash · anlık çarpan",
      viewAll: "Tümünü gör",
      originalsTitle: "Marsilya Orijinal",
      originalsDesc: "Hızlı orijinal oyunlar · tek tık",
      providersDesc: "Tüm stüdyoları gör, filtrele, oyna",
      open: "Aç",
      roomsTitle: "Ne oynamak istersin?",
      roomsDesc: "Casino, spor, espor ve kripto — hepsi tek yerde",
      sportDesc: "Süper Lig, Şampiyonlar Ligi ve canlı bahis",
      esportDesc: "Valorant ve CS2 maçlarına oran",
      cryptoDesc: "BTC, ETH ve LTC · 1 dakikalık tahmin",
      helpTitle: "Takıldığın bir yer mi var?",
      helpDesc: "Duyurular için Telegram kanalımıza katıl, canlı destek 7/24 açık.",
      helpSupport: "Canlı destek",
      quickTitle: "Hızlı giriş",
      providersCount: "{{count}} sağlayıcı",
      loading: "Yükleniyor…",
    },
    providersPage: {
      title: "Sağlayıcılar",
      count: "{{count}} stüdyo",
      search: "Sağlayıcı ara",
      games: "{{count}} oyun",
      catalog: "Katalogda",
      empty: "Bu aramaya uyan sağlayıcı yok.",
      slots: "Slot stüdyoları",
      live: "Canlı stüdyolar",
      active: "{{count}} stüdyoda oyun var",
      slotsLead: "Slot ve orijinal masaları olan stüdyolar. Tıkla, oyunlarını aç.",
      liveLead: "Rulet, blackjack ve canlı masalar.",
      open: "Oyunları aç",
    },
    contactPage: {
      title: "İletişim",
      lead: "Telegram, canlı destek veya talep ile 7/24 bize ulaş.",
      telegramTitle: "Telegram",
      telegramDesc: "Duyuru, yatırım onayı ve hızlı sorular için kanalımız.",
      telegramCta: "Telegram'da yaz",
      liveTitle: "Canlı destek",
      liveDesc: "Site içi sohbetten temsilciye bağlan, anında yazış.",
      liveMeta: "7/24 · anlık mesaj",
      liveCta: "Canlı desteğe bağlan",
      ticketTitle: "Destek talebi",
      ticketDesc: "Çekim, belge veya hesap işleri için talep aç.",
      ticketSubject: "Konu",
      ticketMessage: "Mesajını yaz",
      ticketCta: "Talep oluştur",
      ticketSending: "Gönderiliyor…",
      ticketOpen: "Açık talebin var",
      ticketOk: "Talebin alındı. Profilinden takip edebilirsin.",
      ticketRequired: "Başlık ve mesaj gerekli.",
      loginFirst: "Giriş yap, talep aç",
    },
    fair: {
      title: "Adil oyun",
      subtitle: "Provably fair · SHA-256",
      nextHash: "Sonraki hash",
      nonceSeed: "Nonce · Seed",
      refresh: "Yenile",
    },
    common: {
      play: "Oyna",
      demo: "Demo",
    },
    notFound: {
      title: "Sayfa bulunamadı",
      lead: "Aradığın adres yok veya taşınmış olabilir.",
      home: "Ana sayfaya dön",
    },
    footer: {
      warningTitle: "Kumar tehlikelidir",
      warning: "Kumar bağımlılık yapabilir ve maddi kayba yol açabilir. 18 yaşından küçükler oynayamaz. Kontrolü kaybediyorsan oynamayı bırak.",
      age: "18+",
      telegram: "Telegram kanalımıza katıl",
      rights: "© {{year}} Marsilya Bet. Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      all: "All",
      providers: "Providers",
      contact: "Contact",
      slots: "Slots",
      casino: "Live Casino",
      original: "Marsilya",
    },
    header: {
      search: "Search games or providers",
      home: "Home",
      login: "Log in",
      register: "Sign up",
      logout: "Log out",
      logoutShort: "Exit",
      balance: "Balance",
      wallet: "Wallet",
      bonusShort: "Bonus {{amount}}",
      depositShort: "Deposit",
      account: "My account",
      inbox: "Inbox",
      payments: "Deposit / Withdraw",
      admin: "Admin panel",
      supportDesk: "Support desk",
      cashier: "Cashier panel",
      accountMenu: "Account menu",
      menu: "Menu",
      searchFx: "Search currency",
      walletSettings: "Wallet settings",
    },
    sidebar: {
      menu: "MENU",
      originals: "MARSILYA GAMES",
      games: "GAMES",
      betting: "BETTING",
      account: "ACCOUNT",
      playNowDesc: "Featured games on one screen",
      sport: "Sports",
      esport: "Esports",
      crypto: "Crypto Call",
      telegram: "Telegram channel",
      language: "Language",
      support: "Live support",
      chat: "Chat",
      allGames: "All",
      slots: "Slots",
      liveCasino: "Live Casino",
      marsilya: "Marsilya",
      playNow: "Play now",
      wallet: "Wallet",
      providers: "Providers",
      contact: "Contact",
      mines: "Mines",
      wheel: "Wheel",
      dice: "Dice",
      vip: "VIP / Rank",
    },
    vip: {
      heroTitle: "Play more, rank up, earn more",
      heroLead: "Start at Initié; as approved deposits grow you climb Élite, Prestige, and beyond — with more bonuses and perks each step.",
      heroVolume: "Rank volume = total approved real deposits (IBAN / crypto). Wagering does not count toward rank.",
      register: "Sign up",
      seeLevels: "See levels",
      myRank: "My rank",
      current: "Current rank",
      toNext: "to next threshold",
      approvedDeposits: "approved deposits",
      startInitie: "First rank is Initié — unlocked from 500 ₺ in approved deposits.",
      requiredVolume: "Required volume",
      volumeHint: "Approved deposit total",
      levelBonus: "Level-up bonus",
      levelBonusHint: "Reward when you reach the rank",
      lossBonus: "Loss bonus",
      lossGame: "casino games",
      lossSport: "sports & esports",
      perks: "Perks",
      nextTier: "Next rank",
      rankThreshold: "Minimum approved deposits for this rank: {{amount}}",
      wagerTitle: "Deposits, bonuses & wagering",
      wager1: "Only approved deposits count toward rank; demo balance and cancelled requests are excluded.",
      wager2: "Welcome, weekly, and birthday bonuses go to bonus balance; withdrawal requires completing bonus wagering (e.g. 10x).",
      wager3: "Loss bonuses accrue from play volume and can move to main balance without extra wagering (Account → Bonus).",
      howTitle: "How do you rank up?",
      step1Label: "STEP I",
      step1Title: "Make approved deposits",
      step1Text: "Complete IBAN or crypto deposits. After approval, the amount counts toward rank volume — wagering does not.",
      step2Label: "STEP II",
      step2Title: "Rank rises with volume",
      step2Text: "Total approved deposits cross Initié (500 ₺), Élite (2,000 ₺), Prestige (5,000 ₺) and beyond to update your rank automatically.",
      step3Label: "STEP III",
      step3Title: "Use your rank perks",
      step3Text: "Loss bonus, weekly deposit bonus, rakeback, and VIP support unlock based on your rank.",
      faqTitle: "Frequently asked questions",
      faq1q: "What is the VIP / rank program?",
      faq1a: "Marsilya has six ranks from Initié to Suprême. Loyalty volume is approved real deposits only; each tier adds bonuses and perks.",
      faq2q: "How do I rank up?",
      faq2a: "Approved IBAN or crypto deposits are summed. When you cross a threshold, your rank updates automatically. Track progress in Account and on this page.",
      faq3q: "Does bonus wagering count toward rank?",
      faq3a: "No. Rank volume is approved deposits only. Bonus balance and play turnover are separate from the rank counter.",
      faq4q: "When do I get level-up rewards?",
      faq4a: "Perks and listed rewards apply when you reach a rank threshold. Loss bonuses accrue as you play and can be claimed in Account.",
    },
    lobby: {
      playNow: "Play now",
      heroTitlePrefix: "",
      heroTitleHighlight: "100%",
      heroTitleInline: "welcome bonus",
      heroTitleLine2: "",
      heroDesc: "Match your first deposit. Slots, live casino and Marsilya originals.",
      heroClaim: "Claim bonus",
      bonusKicker: "Live promos",
      bonusTitle: "Bonuses front and center",
      bonusLead: "Welcome, weekly deposit and lossback offers in one place.",
      bonusWelcomeTag: "New players",
      bonusWelcomeTitle: "100% welcome",
      bonusWelcomeDesc: "Match after first deposit loss · 10x wagering",
      bonusWeekTag: "Every week",
      bonusWeekTitle: "Weekly deposit",
      bonusWeekDesc: "Extra bonus on weekly deposits",
      bonusRakeTag: "Slots & originals",
      bonusRakeTitle: "Lossback",
      bonusRakeDesc: "Loss bonus on selected games",
      bonusAll: "See all bonuses",
      egtBannerTitle: "EGT Digital slots",
      egtBannerDesc: "250+ games · Burning Hot, Rise of Ra & more",
      egtBannerCta: "Browse EGT slots",
      popular: "Popular games",
      popularDesc: "Most played Pragmatic titles",
      popularLoading: "Updating popular games…",
      featured: "Featured games",
      originals: "Marsilya Games",
      originalsDesc: "Dice, Aviator, Mines and other originals",
      marsilyaGames: "Marsilya Games",
      marsilyaGamesDesc: "Dice, Aviator, Mines, Plinko, Limbo and Wheel",
      allGames: "All games",
      slots: "Slots",
      slotsDesc: "Pragmatic and other popular slots",
      casino: "Casino",
      liveCasino: "Live Casino",
      liveCasinoDesc: "Roulette, blackjack and live tables",
      seeAll: "View all",
      seeMore: "See more",
      popularSlots: "Popular slot games",
      providers: "Providers",
      providersDesc: "Browse studios on their own, then jump in",
      recent: "Recently played",
      recentDesc: "Tables you just opened",
      removeRecent: "Remove from list",
      originalGames: "Marsilya Games",
      filterAll: "All",
      gamesLoading: "Loading games…",
      showing: "{{count}} shown",
      totalGames: "{{total}} games",
      loadMore: "Load more ({{count}} left)",
      liveCasinoBets: "Casino bets",
      liveGame: "Game",
      liveUser: "User",
      liveTime: "Time",
      liveBet: "Bet",
      liveMult: "Multiplier",
      livePayout: "Payout",
      liveHidden: "Hidden",
    },
    badge: {
      popular: "POPULAR",
      original: "MARSILYA",
    },
    auth: {
      login: "Log in",
      register: "Sign up",
      loginTitle: "Log in to Marsilya Bet",
      registerTitle: "Create account",
      loginLead: "Connect to your account for unlimited play.",
      login2fa: "Enter your Google Authenticator code.",
      registerLead: "Start now with your name, phone and account details.",
      refCode: "Referral code",
      refCodeHint: "Optional. Filled from your invite link, or type it yourself.",
      captcha: "Complete the captcha verification.",
      captchaLabel: "Security code",
      captchaPlaceholder: "Type the code",
      captchaRefresh: "Refresh code",
      visualLead: "Slots, live casino and Marsilya originals. Join Telegram for drops and news.",
    },
    account: {
      overview: "Account",
      settings: "Settings",
      offers: "Bonuses",
      prefs: "Preferences",
      password: "Password",
      oldPass: "Old password",
      newPass: "New password",
      newPass2: "Confirm new password",
      save: "Save",
      twoFaTitle: "Two-factor",
      twoFaLead: "Scan the QR code, then enter the code from your authenticator app.",
      privacy: "Privacy",
      privacyLead: "These settings control how other players see you.",
      community: "Community",
      prefGhost: "Enable ghost mode",
      prefGhostDesc: "Your username stays hidden on public bet feeds and previews.",
      prefWins: "Hide all statistics",
      prefWinsDesc: "Wins, losses and wagered totals stay hidden from other users.",
      prefRace: "Hide race statistics",
      prefRaceDesc: "Your race stats stay hidden from other users.",
      prefTips: "Block incoming tips",
      prefTipsDesc: "Stops others from tipping you in chat.",
      prefWait: "Please wait about 30 seconds for updates to take effect.",
      prefInstant: "Changes apply instantly and save to your account.",
      experience: "Experience",
      experienceLead: "Streamer, sound and notification preferences.",
      privateProfile: "Private profile",
      privateProfileDesc: "Mask email, phone and full name on this page.",
      hideActivity: "Hide transaction amounts",
      hideActivityDesc: "Shows bet and win amounts as •••• in your history.",
      stealthIp: "Hide IP",
      stealthIpDesc: "Hides your last IP on the session list.",
      hideBonus: "Hide bonus balance",
      hideBonusDesc: "Hides the bonus amount in the top menu while streaming.",
      muteSfx: "Mute game sounds",
      muteSfxDesc: "Turns off dice, wheel and original game effects.",
      rainIgnore: "Ignore rain and chat drops",
      rainIgnoreDesc: "Hides rain and drop notices in chat.",
      streamerOn: "Streamer",
      ghostOn: "Ghost",
      privateHint: "Profile details hidden",
      wagered: "Wagered",
      ipHidden: "IP hidden",
      prefSaved: "Preferences saved",
      verified: "Verified",
      copy: "Copy",
      emailLead: "Your email is used for official contact and account security.",
      phoneTitle: "Phone number",
      phoneLead: "The phone number on your account.",
      deposit: "Deposit",
      withdraw: "Withdraw",
      paylog: "Deposits & withdrawals",
      history: "Transactions",
      security: "Security",
      inbox: "Messages",
      profile: "Profile",
      profileLead: "Your account info, security status and quick actions.",
      balance: "Available balance",
      bonusLocked: "non-withdrawable",
      session: "Session",
      loginRequired: "Log in to access your account.",
      noPhone: "No phone on file",
      username: "Username",
      email: "Email",
      fullName: "Full name",
      phone: "Phone",
      totalDeposit: "Total deposited",
      rankNow: "Your current rank",
      rankNext: "You need {{amount}} more in deposits to reach {{name}}.",
      rankMax: "You are at the top rank. Suprême.",
      rankDeposited: "Total deposited {{amount}}",
      rankNeed: "next threshold {{amount}}",
      rankTitle: "Rank-up and leaderboard",
      rankLead: "Deposits set your rank. The highest-ranked player leads the table.",
      rankBoard: "Leaderboard",
      rankLeader: "Highest rank",
      rankEmpty: "No ranking yet",
      rankAllLevels: "All levels and perks",
      photoType: "JPG or PNG only",
      photoMax: "Photo must be 2 MB or smaller",
      photoOk: "Profile photo updated",
      photoHint: "JPG/PNG · max 2 MB",
      weeklyTitle: "Weekly deposit bonus",
      weeklyDesc: "Seven days after signup, claim 5% of that week’s deposits every week.",
      weeklyWeek: "Deposited this week",
      weeklyBonus: "Bonus waiting",
      weeklyClaim: "Claim {{amount}}",
      weeklyBusy: "Adding…",
      weeklyClaimed: "Weekly bonus added",
      weeklyDone: "You claimed this week. It opens again on Monday.",
      weeklyLocked: "Unlocks 7 days after signup. Left: {{time}}",
      weeklyNeed: "Deposit this week to unlock the bonus",
      rakeTitle: "Loss bonus",
      rakeDesc: "1% of each real-money losing bet collects here. It is not added automatically — you claim it.",
      affiliate: "Affiliate",
      affiliateCode: "Affiliate code",
      affiliateRate: "Rate",
      affiliateEarned: "Your earnings",
      affiliateHouse: "Referral house",
      affiliateReferrals: "Signups",
      affiliateLead: "You earn a share of the house from players who register with your link.",
      twoFa: "2FA security",
      twoFaOn: "Enabled",
      twoFaOff: "Disabled",
      depositBtn: "Make deposit",
      withdrawBtn: "Request withdrawal",
      historyBtn: "Transaction history",
      supportChat: "Open live support",
      supportNew: "Message admin",
      welcomeBonus: "100% welcome bonus",
      welcomeBonusDesc: "Get a one-time 100% bonus after losing your first deposit. 10x wagering: 1,000 ₺ bonus needs 10,000 ₺ played. Withdrawals unlock after that.",
      bonusWagerTitle: "Wagering requirement",
      bonusWagerProgress: "{{wagered}} / {{required}} wagered",
      bonusWagerLeft: "Wagering left to withdraw: {{left}}",
      bonusWagerDone: "Wagering complete. Bonus converted to cash.",
      bonusWagerLocked: "The 10x bonus wager must finish before a withdrawal.",
      bonusClaimedNote: "Bonus is on your account. Play originals at 10x wagering; payouts follow the 2/10 house bag.",
      copyInvite: "Copy invite link",
      bankTransfer: "Bank transfer",
      bankTransferSub: "TRY deposit",
      crypto: "Crypto",
      cryptoSub: "USDT, TRX, LTC, XMR…",
      hideName: "Hide username",
      hideNameDesc: "Your name shows as Hidden on live bets and the win feed.",
      hideBalance: "Hide balance",
      hideBalanceDesc: "Other players won’t see your balance on profile previews.",
      streamer: "Streamer mode",
      streamerDesc: "Softens balances and big wins while you share your screen.",
      loginAlerts: "Login alerts",
      loginAlertsDesc: "Email me when a new device signs in.",
      sessions: "Sessions",
      sessionsLead: "Devices signed into your account. Close anything you don’t recognize.",
      thisDevice: "This device",
      currentSession: "Active session",
      verify: "ID verification",
      verifyTitle: "ID verification",
      verifyLead: "Verify your TCKN before IBAN withdrawals. The official name is written to the account.",
      verifyPending: "Unverified",
      verifyOk: "Verified",
      verifyNeed: "TCKN updates your legal name. The IBAN holder must match that name.",
      verifyIbanMatch: "The IBAN account name must match the name on your ID. Withdrawals are rejected if they differ.",
      kycTckn: "National ID (TCKN)",
      kycSubmit: "Confirm identity",
      kycIbanNeed: "Complete ID verification before an IBAN withdrawal.",
      marketing: "Promo emails",
      marketingDesc: "Bonuses, races and reload drops.",
      notifySite: "Site notifications",
      notifySiteDesc: "Deposit, withdraw and support updates.",
      joined: "Joined",
      kyc: "ID verification",
      recover: "Recovery email",
      recoverDesc: "Used if you lose access to 2FA.",
    },
    games: {
      kicker: "MARSILYA ORIGINAL",
      betLabel: "Bet ({{symbol}})",
      manual: "Manual",
      auto: "Auto",
      risk: "Risk",
      riskLow: "Low",
      riskMed: "Medium",
      riskHigh: "High",
      rows: "Rows",
      ballCount: "Ball count",
      totalBet: "Total bet {{amount}}",
      bet: "Bet",
      stop: "Stop",
      targetMult: "Target multiplier",
      fly: "Launch",
      spin: "Spin wheel",
      autoSpin: "Auto spin",
      heads: "Heads",
      tails: "Tails",
      start: "Start",
      cashout: "Cash out",
      cancelRefund: "Cancel · refund {{amount}}",
      nextBox: "Next tile",
      mineCount: "Mine count",
      bonusNote: "Bonus {{amount}} · wager {{wagered}} / {{required}} · 10x required before withdraw.",
      loading: "Loading game…",
      backHub: "Games",
      mute: "Mute",
      unmute: "Unmute",
      bonusChip: "Bonus {{amount}}",
      mines: {
        title: "Mines",
        desc: "Set mines, reveal safe tiles, cash out before hitting a mine.",
      },
      plinko: {
        title: "Plinko",
        desc: "Pick risk and rows, drop the ball.",
      },
      limbo: {
        title: "Limbo",
        desc: "Pick a target multiplier. Win if the result passes it.",
      },
      wheel: {
        title: "Wheel",
        desc: "Spin the wheel and take the slice multiplier.",
      },
      dice: {
        title: "Dice",
        desc: "Pick 1–6. Hit it for 20x.",
      },
      defaultTitle: "Game",
    },
    play: {
      back: "Back",
      mute: "Mute (M)",
      unmute: "Unmute (M)",
      demoMode: "Demo · ",
      demoAlert: "You are in demo mode — try the game without signing up. To play for real,",
      or: "or",
      register: "sign up",
      login: "log in",
      deposit: "Deposit",
      loading: "Loading game…",
      defaultTitle: "Game",
      fullscreen: "Fullscreen",
      exitFullscreen: "Exit fullscreen",
      gateBalance: "Balance",
      currency: "Currency",
      currencyTry: "Games open in Turkish lira (TRY) only.",
      registerBtn: "Register",
      loginBtn: "Log in",
      demoBtn: "Fun play",
      realBtn: "Real balance",
      askMode: "Real balance or demo?",
      moreFrom: "More from {{provider}}",
      viewAll: "View all",
      providers: "Providers",
      theatre: "Widen",
      real: "Real",
      fun: "Fun",
    },
    playHub: {
      title: "Play now",
      desc: "Slots, live casino and Marsilya originals — pick and start instantly.",
      exploreSlots: "Browse slots",
      goOriginals: "Go to originals",
      categories: "Game categories",
      slotsDesc: "Pragmatic and top provider slots",
      casinoDesc: "Blackjack, roulette and live tables",
      gamesLabel: "games",
      liveLabel: "live tables",
      statOriginals: "6 original games",
      statInstant: "Instant launch",
      statFair: "Provably fair",
      popularTitle: "Popular tables",
      popularDesc: "Most played picks",
      pickBlackjack: "Live & RNG blackjack",
      pickRoulette: "European roulette",
      pickAviator: "Crash · live multiplier",
      viewAll: "View all",
      originalsTitle: "Marsilya Originals",
      originalsDesc: "Fast originals · one click",
      providersDesc: "Browse every studio and jump in",
      open: "Open",
      roomsTitle: "What do you want to play?",
      roomsDesc: "Casino, sports, esports and crypto — all in one place",
      sportDesc: "Süper Lig, Champions League and live betting",
      esportDesc: "Odds for Valorant and CS2 matches",
      cryptoDesc: "BTC, ETH and LTC · 1 minute call",
      helpTitle: "Need a hand?",
      helpDesc: "Join our Telegram channel for updates, live support is open 24/7.",
      helpSupport: "Live support",
      quickTitle: "Quick start",
      providersCount: "{{count}} providers",
      loading: "Loading…",
    },
    providersPage: {
      title: "Providers",
      count: "{{count}} studios",
      search: "Search providers",
      games: "{{count}} games",
      catalog: "In catalog",
      empty: "No provider matches this search.",
      slots: "Slot studios",
      live: "Live studios",
      active: "{{count}} studios with games",
      slotsLead: "Studios with slots and originals. Tap to open their games.",
      liveLead: "Roulette, blackjack and live tables.",
      open: "Open games",
    },
    contactPage: {
      title: "Contact",
      lead: "Reach us 24/7 on Telegram, live chat or a support ticket.",
      telegramTitle: "Telegram",
      telegramDesc: "Announcements, deposit checks and quick questions.",
      telegramCta: "Open Telegram",
      liveTitle: "Live support",
      liveDesc: "Connect to an agent in the on-site chat.",
      liveMeta: "24/7 · realtime",
      liveCta: "Start live chat",
      ticketTitle: "Support ticket",
      ticketDesc: "Open a ticket for withdrawals, documents or account issues.",
      ticketSubject: "Subject",
      ticketMessage: "Write your message",
      ticketCta: "Create ticket",
      ticketSending: "Sending…",
      ticketOpen: "You already have a ticket",
      ticketOk: "Ticket received. Track it from your profile.",
      ticketRequired: "Subject and message are required.",
      loginFirst: "Log in to open a ticket",
    },
    fair: {
      title: "Fair play",
      subtitle: "Provably fair · SHA-256",
      nextHash: "Next hash",
      nonceSeed: "Nonce · Seed",
      refresh: "Refresh",
    },
    common: {
      play: "Play",
      demo: "Demo",
    },
    notFound: {
      title: "Page not found",
      lead: "The address you opened does not exist or may have moved.",
      home: "Back to home",
    },
    footer: {
      warningTitle: "Gambling is dangerous",
      warning: "Gambling can be addictive and may cause financial loss. 18+ only. If you are losing control, stop playing.",
      age: "18+",
      telegram: "Join our Telegram channel",
      rights: "© {{year}} Marsilya Bet. All rights reserved.",
    },
  },
};
